(function () {
  /* Kennzeichnet Seiten mit CTA-Leiste, damit unten genug Platz bleibt –
     funktioniert auf der Startseite genauso wie unter /pages/kern-tauschen. */
  if (document.querySelector('.bulp-bar')) {
    document.body.classList.add('bulp-has-bar');
  }

  var feld = document.getElementById('bulp-hoehe');
  var knopf = document.getElementById('bulp-pruefen');
  var box = document.getElementById('bulp-ergebnis');
  if (!feld || !knopf || !box) return;

  var WA = 'https://wa.me/4915251741750';

  function spur(ergebnis) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'bettup_hoehen_check', ergebnis: ergebnis, page_path: window.location.pathname });
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'bettup_hoehen_check', { ergebnis: ergebnis });
      }
    } catch (e) {}
  }

  function zeige(status, titel, text, cta) {
    box.className = 'bulp-result ' + status;
    box.innerHTML = '<strong>' + titel + '</strong>' + text + (cta || '');
  }

  function pruefen() {
    var h = parseFloat(String(feld.value).replace(',', '.'));

    if (isNaN(h) || h <= 0) {
      zeige('is-no', 'Bitte eine Höhe eingeben.', 'Miss den alten Kern an der Seite – nicht das ganze Bett.');
      return;
    }

    if (h >= 18 && h <= 23) {
      zeige(
        'is-yes',
        'Passt – bei ' + h + ' cm sind wir genau richtig.',
        'Alle bettUP-Kerne gibt es in dieser Höhe. Jetzt fehlen nur noch Größe und Härtegrad.',
        '<a class="bulp-btn bulp-btn--primary" href="#kerne">Weiter zu den Kernen</a>'
      );
      spur('passt');
    } else if (h > 23 && h <= 26) {
      zeige(
        'is-no',
        h + ' cm liegt knapp über unserem Standard.',
        'Oft lässt sich das mit einem Topper ausgleichen – manchmal auch nicht. Das schauen wir uns lieber kurz gemeinsam an, bevor du bestellst.',
        '<a class="bulp-btn bulp-btn--wa" href="' + WA + '">Kurz per WhatsApp klären</a>'
      );
      spur('grenzfall');
    } else {
      zeige(
        'is-no',
        h + ' cm liegt außerhalb unserer Standardhöhen (18–23 cm).',
        'Damit passt ein Standardkern nicht sicher. Schreib uns die Maße – wir sagen dir ehrlich, ob sich ein Tausch bei dir lohnt oder nicht.',
        '<a class="bulp-btn bulp-btn--wa" href="' + WA + '">Maße schicken</a>'
      );
      spur('passt_nicht');
    }
  }

  knopf.addEventListener('click', pruefen);
  feld.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); pruefen(); }
  });
})();